import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryActorMounted extends ConditionRegistryCategory {
    label = 'Dargestellter Akteur';
    constructor(parent) {
        super(parent);
        super.init();
    }
    toActor = () => new ConditionRegistryItem({
        /*  label: 'Akteur wechseln',
        params: { core: ['actorName'] }, */
        eval: ({ rightChildEvaluator }) => !!rightChildEvaluator && rightChildEvaluator.isConditionTrue,
        modifyContext: {
            actor: context => context[context.evaluator.valueOf.actorName] // || context.byTag(context.evaluator.valueOf.actorName)
        }
    });
    isInAspect = () => new ConditionRegistryItem({
        /*   label: 'is in Aspect',
        params: { core: ['aspectName'] } */
        eval: ({ actor, condition }) => actor.parent.name === condition.local.valueOf.aspectName
    });
}
